/**
 * Der Reiter „Spedition" des Bestell-Drawers - neuer Reiter (kein Bestandsvorbild in `index.html`),
 * Auftraggeber-Wunsch vom 2026-08-20 (siehe Kopfkommentar `drawerRechte.ts` und
 * `docs/superpowers/decisions/2026-08-20-reiter-spedition.md`). Bauplan wie `MainTab/
 * BestellungTab.tsx`: Reiterkomponente + Fragment-Teilstuecke ohne eigene Huelle, `Abschnitt` als
 * Abschnittsrahmen, gemeinsames `typen.ts`.
 *
 * Vier Abschnitte, in dieser Reihenfolge (Auftrag, Tabelle „Vier Abschnitte"):
 *
 *   sec('ship-sendung',     'DSV-Sendung')       Suchfeld bzw. verknuepfte Sendung (inkl. DSV-
 *                                                Sendungsnr. und Container-Nr., `DsvSendung.tsx`) -
 *                                                im Modus "air" ersetzt `FlugSendung.tsx`, im Modus
 *                                                "road" `StrassenSendung.tsx` diesen
 *                                                Abschnittsinhalt, siehe unten.
 *   sec('ship-referenzen',  'Referenzen')        Speditionsportal (Tracking-/Container-Nr. stand
 *                                                hier bis zur Korrektur „Trackingabschnitt ersatzlos
 *                                                entfernen", 2026-08-25 - redundant zum Abschnitt
 *                                                „DSV-Sendung" oben, siehe `Referenzen.tsx`)
 *   sec('ship-transport',   'Transportdaten')    ETD/ETA/vsl. LT Buchen/Aufschlag/Container/-Volumen,
 *                                                bei air/road auch der Haken „Liefertermine fixiert"
 *   sec('ship-stationen',   'Tracking / Stationen')  die Stufen des Zeitstrahls, zugeklappt
 *
 * FUENFTER Abschnitt, additiv (2026-09-04): sec('ship-historie', 'DSV-Historie') - ALLE rohen
 * `shipment_events`-Zeilen der Sendung, UNGEFILTERT (`DsvHistorie.tsx`), zugeklappt wie
 * `ship-stationen`. Nur sichtbar, solange eine Sendung verknuepft ist (`sendung !== null`) - der
 * See/Flug-Umschalter (unten) betrifft ihn nicht direkt, weil `FlugSendung`/`DsvSendung` ohnehin nie
 * gleichzeitig ein `sendung` liefern.
 *
 * Feature "See/Flug-Umschaltung" (2026-08-26, Spec docs/superpowers/specs/2026-08-26-spedition-
 * see-flug-design.md): ein Umschalter oberhalb der vier Abschnitte setzt `order_extras.
 * transport_mode` ('see' Default, 'air' neu). Im Modus "air" ersetzt `FlugSendung` den Abschnitt
 * „DSV-Sendung" (Suchfeld/Verknuepfung entfallen), Transport.tsx blendet die Container-Felder aus
 * (E4), Stationen.tsx zeigt den manuellen Status statt der Stufenliste (E4, ueber Task 7/8
 * verdrahtet). See -> Flug ist gesperrt, solange eine DSV-Sendung verknuepft ist (E3) -
 * serverseitig nochmal durchgesetzt (TransportModeGesperrtError, backend/src/dsv/verknuepfung.ts),
 * hier nur die Oberflaechen-Haelfte. Flug -> See bleibt jederzeit erlaubt, auch bei laufender
 * Sperre - erst der umgekehrte Weg braucht die geloeste Verknuepfung.
 *
 * DRITTE Transportart "road" (Asana-Ticket 1218176179911324, "Zusaetzlicher LKW Speditionstyp"),
 * reine Handpflege wie "air", ohne DSV-Anbindung, Weg 1-2 Werktage: dritter Knopf „Straße" im
 * Umschalter, im Modus "road" ersetzt `StrassenSendung` denselben Abschnitt „DSV-Sendung" wie
 * `FlugSendung` es fuer "air" tut. Die Sperre gilt jetzt fuer BEIDE Wege weg von See - See -> Flug
 * UND See -> Straße sind gesperrt, solange eine DSV-Sendung verknuepft ist, mit demselben Titel
 * ("Erst die DSV-Verknüpfung lösen"); Flug -> See und Straße -> See bleiben jederzeit frei.
 * Serverseitig durchgesetzt ueber denselben `TransportModeGesperrtError` ("jeder Weg weg von See"),
 * hier wieder nur die Oberflaechen-Haelfte.
 *
 * ================= RECHTE: dieser Reiter prueft selbst KEINE =================
 *
 * Wie `MainTab/BestellungTab.tsx`: `rechte` steht in `SpeditionTabProps` (die Aufrufform reicht es
 * herein), wird hier aber NICHT gelesen - gesperrt wird der Reiter ueber den Durchgang in
 * `Drawer.tsx` (`DRAWER_TAB_EDIT_PERMISSIONS['ship'] = 'edit_orders'`), nicht ueber eine zweite
 * Rechtequelle in diesem Modul.
 *
 * Die Ausnahme (Spec 2026-10-17, „Kategorie zuweisen …“ am DSV-Beleg): `rechte` wird gelesen, um die
 * angebotenen Kategorien je Dokumenttyp zu filtern (`lib/belegKategorien.ts`) - das Dokumentrecht ist
 * ein anderes als das Schreibrecht des Reiters. Die Auswahl traegt dafuer ein eigenes
 * `data-permission` (siehe `BelegKategorieWahl.tsx`).
 *
 * Die zweite Ausnahme (Plan „Zollinstruktionen im Hub“, Task 11): ganz oben, noch VOR der Transportart, steht der Knopf
 * „Zollinstruktionen anstoßen“ (`Zollinstruktionen/ZollKnopfLazy.tsx` mit dem nachgeladenen Chunk `ZollKnopf.tsx`, Spec 2026-10-30-zollinstruktionen-design.md). Er
 * verlangt `manage_documents` UND `manage_tasks` (das Erzeugen legt die Datei ab und hakt den Task ab) - nicht `edit_orders`, das der
 * Reiter sonst verlangt. Fehlt eines der beiden, ist er gesperrt und nennt das Recht; dafuer traegt er ein eigenes `data-permission`.
 * „Angestossen“ ist die Bestellung, sobald sie einen ERLEDIGTEN Task „Zollinstruktionen an Spedition senden (Outlook)“ hat
 * (`lib/zollinstruktionen.ts`) - auch ein von Hand abgehakter zaehlt. Der Melder des Dialogs und der Rueckruf nach dem Erzeugen
 * kommen als Props von `App.tsx` (Rolldown, siehe `typen.ts`).
 */
import { useRef } from "react";
import { Abschnitt } from "../Abschnitt.tsx";
import { DsvSendung } from "./DsvSendung.tsx";
import { FlugSendung } from "./FlugSendung.tsx";
import { StrassenSendung } from "./StrassenSendung.tsx";
import { Referenzen } from "./Referenzen.tsx";
import { Transport } from "./Transport.tsx";
import { Stationen } from "./Stationen.tsx";
import { DsvHistorie } from "./DsvHistorie.tsx";
import { DsvBelege } from "../DsvBelege.tsx";
import { belegKategorieEinstellung } from "../../../lib/belegKategorien.ts";
import { DsvGruppenVergleich } from "../../OrderGroups/DsvGruppenVergleich.tsx";
import { meldeNachladeFehler } from "../../../state/fehlerStapel.ts";
import { bestellbezeichnung, mitBestellbezug } from "../../../lib/bestellkennung.ts";
import { useMontiertRef } from "../../../state/useMontiertRef.ts";
import { ZollKnopfLazy } from "../../Zollinstruktionen/ZollKnopfLazy.tsx";
import type { SpeditionTabProps } from "./typen.ts";

export type { SpeditionTabProps };

/**
 * R4 (Fehleranzeige Paket 2): „Kategorie zuweisen …“ am DSV-Beleg ist gelungen, nur das Neuladen der Belegliste (und der
 * Bestellung) danach scheiterte. Der Satz sagt, was gespeichert ist und was veraltet ist; die Ursache haengt
 * `meldeNachladeFehler` nur an, wenn sie nicht zum Wiederholen raet. Das Gegenstueck im Reiter Dokumente
 * (`DokumenteTab.tsx#belegZugeordnet`) nennt die Checkliste.
 *
 * R3 (Review Task 11, G-4): das Neuladen der Belege kann dauern. Ist der Reiter bis dahin abgebaut (Drawer geschlossen)
 * oder zeigt dieselbe Instanz eine andere Bestellung (Drawer-Wechsel), liest der Nutzer den Satz nicht mehr neben der
 * Bestellung, die er meint; dann steht `Bestellung <Bezeichnung>:` davor (`mitBestellbezug`).
 */
const KATEGORIE_NACHLADEN_FEHLGESCHLAGEN_MELDUNG =
  "Die Kategorie ist gespeichert, die Belegliste konnte aber nicht aktualisiert werden. Bitte neu laden.";

export function SpeditionTab(props: SpeditionTabProps) {
  const {
    bestellung,
    sendung,
    vorschlag,
    zeitstrahl,
    historie,
    belege,
    onBelegeNeuLaden,
    rechte,
    onAendern,
    onPortal,
    sendungsSuche,
    onVerknuepfen,
    onLoesen,
    laeuft,
    gruppe,
    bestellungen,
    onGruppenSendungSetzen,
    zollMelder,
    onZollErzeugt,
  } = props;

  const transportMode = bestellung.transportMode ?? "see";
  // Jeder Weg WEG von See ist gesperrt, solange eine DSV-Sendung verknuepft ist (Spec E3, erweitert
  // um "road" - Asana 1218176179911324): See -> Flug UND See -> Straße. `dsvVerknuepft` statt
  // `sendung !== null`: `sendung` wird asynchron nachgeladen (Drawer.tsx) und ist beim ersten
  // Render noch `null`, obwohl bereits eine Verknuepfung besteht - `dsvVerknuepft` kommt dagegen
  // synchron mit der Bestellung selbst (backend/src/domaene/orders.ts, dieselbe EXISTS-Abfrage gegen
  // order_shipments wie im Zeitstrahl-Badge, ZeitstrahlSeite.tsx).
  const wechselGesperrt = bestellung.dsvVerknuepft === true;
  const id = bestellung.id as string;
  // Welche Bestellung der Reiter JETZT zeigt und ob es ihn noch gibt: ein Neuladen der Belege endet nach Sekunden, und
  // dann braucht es den Stand von heute, nicht den des Klicks (siehe `KATEGORIE_NACHLADEN_FEHLGESCHLAGEN_MELDUNG`).
  // `"layout"`: die Ref wird im selben Schritt falsch, in dem der Drawer den Reiter abbaut (`useMontiertRef`).
  const montiertRef = useMontiertRef("layout");
  const aktuelleBestellungRef = useRef(id);
  aktuelleBestellungRef.current = id;
  // Mitglieder der Sammelsendung: das Groessere aus der Zaehlung im Store (Bestellungen mit derselben
  // Sendungsnummer, Schluessel `Order.dsvShipmentNo`, nicht `shipmentOrderGroup`) und den verknuepften
  // Bestellungen der Sendung - jede Quelle kann hinterherhinken (Store nicht geladen / Sendung nicht nachgeladen).
  const sendungsNr = bestellung.dsvShipmentNo ?? sendung?.dsvShipmentNo ?? null;
  const imStore = bestellungen && sendungsNr ? bestellungen.filter((o) => o.dsvShipmentNo === sendungsNr).length : 0;
  const mitgliederAnzahl = Math.max(imStore, sendung?.verknuepfteBestellungen.length ?? 0);
  // Auswahl „Kategorie zuweisen …“ an den DSV-Belegen (Spec 2026-10-17). Die Rechte prueft dieser Reiter
  // sonst nicht (siehe Kopfkommentar „RECHTE“) - hier aber je Kategorie, denn der Reiter-Durchgang
  // (`edit_orders`) deckt das Dokumentrecht nicht ab; der Server urteilt ohnehin verbindlich.
  const belegKategorie = belegKategorieEinstellung(bestellung, bestellungen, sendung, rechte, () => {
    // Das eigene `.catch`: ein gescheitertes Neuladen heisst nur „Liste veraltet“, die Zuordnung steht (R4). Der Eintrag
    // sagt das und raet nicht zum Wiederholen (`meldeNachladeFehler`): sonst ordnete der Nutzer ein zweites Mal zu.
    // `id` und `bestellung` sind die der Ausfuehrung, in der geklickt wurde (die Bestellung ist beim START festgehalten);
    // scheitert das Neuladen erst nach einem Drawer-Wechsel, nennt der Satz sie (R3, Review Task 11, G-4).
    void Promise.resolve(onBelegeNeuLaden?.()).catch((fehler: unknown) => {
      console.error(`DSV-Belege der Bestellung "${id}" konnten nach der Zuordnung nicht neu geladen werden:`, fehler);
      const sichtbar = montiertRef.current && aktuelleBestellungRef.current === id;
      meldeNachladeFehler(
        fehler,
        sichtbar ? KATEGORIE_NACHLADEN_FEHLGESCHLAGEN_MELDUNG : mitBestellbezug(KATEGORIE_NACHLADEN_FEHLGESCHLAGEN_MELDUNG, bestellung, id),
      );
    });
  });

  return (
    <>
      <ZollKnopfLazy
        ziel={{ art: "bestellung", id }}
        titel={`Bestellung ${bestellbezeichnung(bestellung, id)}`}
        rechte={rechte}
        bestellungen={[bestellung]}
        melder={zollMelder}
        onErzeugt={onZollErzeugt}
      />

      <div className="field-grid">
        <div className="field wide">
          <label>Transportart</label>
          <div className="transportmodus-umschalter" role="group" aria-label="Transportart">
            <button
              type="button"
              aria-pressed={transportMode === "see"}
              onClick={() => transportMode !== "see" && onAendern(id, { transportMode: "see" })}
            >
              See
            </button>
            <button
              type="button"
              aria-pressed={transportMode === "air"}
              disabled={wechselGesperrt}
              title={wechselGesperrt ? "Erst die DSV-Verknüpfung lösen" : undefined}
              onClick={() => transportMode !== "air" && onAendern(id, { transportMode: "air" })}
            >
              Flug
            </button>
            <button
              type="button"
              aria-pressed={transportMode === "road"}
              disabled={wechselGesperrt}
              title={wechselGesperrt ? "Erst die DSV-Verknüpfung lösen" : undefined}
              onClick={() => transportMode !== "road" && onAendern(id, { transportMode: "road" })}
            >
              Straße
            </button>
          </div>
        </div>
      </div>

      <Abschnitt
        schluessel="ship-sendung"
        titel={transportMode === "air" ? "Flug-Sendung" : transportMode === "road" ? "Straßen-Sendung" : "DSV-Sendung"}
      >
        {transportMode === "air" ? (
          <FlugSendung bestellung={bestellung} onAendern={onAendern} />
        ) : transportMode === "road" ? (
          <StrassenSendung bestellung={bestellung} onAendern={onAendern} />
        ) : (
          gruppe?.status === "active" && bestellungen && onGruppenSendungSetzen ? (
            <DsvGruppenVergleich
              gruppe={gruppe}
              bestellungen={bestellungen}
              sendungsSuche={sendungsSuche}
              onBestaetigen={onGruppenSendungSetzen}
            />
          ) : (
            <DsvSendung
              sendung={sendung}
              vorschlag={vorschlag}
              sendungsSuche={sendungsSuche}
              onVerknuepfen={onVerknuepfen}
              onLoesen={onLoesen}
              laeuft={laeuft}
              bestellungId={id}
              mitgliederAnzahl={mitgliederAnzahl}
              bestellNr={bestellung.orderNo as string | undefined}
            />
          )
        )}
      </Abschnitt>

      <Abschnitt schluessel="ship-referenzen" titel="Referenzen">
        <div className="field-grid">
          <Referenzen
            bestellung={bestellung}
            onAendern={onAendern}
            onPortal={onPortal}
            sendung={sendung}
          />
        </div>
      </Abschnitt>

      <Abschnitt schluessel="ship-transport" titel="Transportdaten">
        <div className="field-grid">
          <Transport bestellung={bestellung} sendung={sendung} onAendern={onAendern} />
          {/* Liquiditaetsplanung: Raten mit Anker ETD/ETA zaehlen bei Flug/LKW nur mit diesem Haekchen als fix. */}
          {(transportMode === "air" || transportMode === "road") && (
            <div className="field wide">
              <label className="haken-feld">
                <input
                  type="checkbox"
                  checked={!!bestellung.transportDatesFixed}
                  onChange={(e) => onAendern(id, { transportDatesFixed: e.currentTarget.checked })}
                />
                Liefertermine fixiert
              </label>
              <p className="haken-hinweis">Bestätigte Termine — Raten zählen in der Liquiditätsplanung als fix</p>
            </div>
          )}
        </div>
      </Abschnitt>

      <Abschnitt schluessel="ship-stationen" titel="Tracking / Stationen">
        <Stationen
          zeitstrahl={zeitstrahl}
          transportMode={transportMode}
          airStatus={bestellung.airStatus}
          id={id}
          onAendern={onAendern}
          airEtd={bestellung.airEtd}
          airEta={bestellung.airEta}
          airAbsina={bestellung.airAbsina}
          roadStatus={bestellung.roadStatus}
          roadEtd={bestellung.roadEtd}
          roadEta={bestellung.roadEta}
        />
      </Abschnitt>

      {sendung && (
        <Abschnitt schluessel="ship-historie" titel="DSV-Historie">
          <DsvHistorie historie={historie} />
        </Abschnitt>
      )}

      {/*
        Abschnitt "DSV-Belege" (Auftrag "DSV-Belege (Zustellbeleg + Rechnung) in der Bestellung
        anzeigen", 04.09.2026) - ANDERS als "ship-historie" oben NICHT an `sendung !== null` gebunden:
        ein Beleg gehoert zur BESTELLUNG, nicht zur Anzeige der aktuell verknuepften Sendung. `belege`
        wird NACH JEDEM Verknuepfen/Loesen neu geladen (Nachbesserung, Pruefer-Befund, 05.09.2026:
        `App.tsx#speditionVerknuepfen`/`#speditionLoesen` - `order_id` bewegt sich seit dem Basis-Commit
        `ac18c78b` live mit der Sendungsverknuepfung, siehe `backend/src/dsv/belegVerknuepfung.ts`).
      */}
      <Abschnitt schluessel="ship-belege" titel="DSV-Belege">
        <DsvBelege bestellungId={id} belege={belege} kategorie={belegKategorie} />
      </Abschnitt>
    </>
  );
}
